import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import { ApiService } from '../../../_services/api.service';
import { Endpoints } from '../../../endpoints';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError, finalize, tap, of } from 'rxjs';
import { DialogService } from '../../../_modal/dialog.service';
import { environment } from '../../../../../environments/environment';
import { LoggerService } from '../../../_services/logger.service';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import {MatAnchor} from "@angular/material/button";
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import {HttpClient} from "@angular/common/http";
import {CommonResponse} from "../../../_models/Response";
@Component({
  selector: 'app-client-details',

  standalone: true,
    imports: [CommonModule, MatCardModule, RouterOutlet, MatAnchor, RouterLink, RouterLinkActive],
  templateUrl: './client-details.component.html',
  styleUrls: ['./client-details.component.scss'],
  providers: [Endpoints, HttpClient]
})
export class ClientDetailsComponent implements OnInit {
  clientId: string = '';
  clientDetails: any;
  @Input({required: true}) id : string

  constructor(
    private route: ActivatedRoute,
    private http : HttpClient,
    private endpoints: Endpoints,
    private spinner: NgxSpinnerService,
    private dialogService: DialogService,
    private loggerService: LoggerService,
    public themeService: CustomizerSettingsService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.clientId = params.get('id') || '';
      if (this.clientId) {
        this.fetchClientDetails(this.clientId);
      }
    });
  }

fetchClientDetails(clientId: string) {
  const clientUrl = `${this.endpoints.client_base_endpoint}/${clientId}`;
  console.log('➡️ Requête vers :', clientUrl);

  this.http.get<CommonResponse>(clientUrl).subscribe({
    next: (response) => {
      console.log('⬅️ Réponse reçue du backend :', response);

      if (response.status) {
        this.clientDetails = response.data;
        console.log('✅ clientDetails mis à jour :', this.clientDetails);

        // Si tu utilises un service de logging
        this.loggerService.log('client_details', this.clientDetails);
      } else {
        console.warn('⚠️ Status false du backend :', response.message);
      }
    },
    error: (err) => {
      console.error('❌ Erreur lors de la récupération du client :', err);
    },
    complete: () => {
      console.log('🔹 Requête fetchClientDetails terminée');
    }
  });
}


  handleError(error: { status: number }) {
    this.spinner.hide();
    this.loggerService.log('error', error);

    if (error.status === 401) {
      this.dialogService.open('Token Expired. Redirecting to Login Page', environment.error_message_type, 'danger', environment.error_icon);
      setTimeout(() => {
        window.location.href = '/authentication';
      }, 3000);
    } else if (error.status === 500) {
      this.dialogService.open('Internal Server Error!!!', environment.error_message_type, 'danger', environment.error_icon);
    } else {
      this.dialogService.open('Bad Request. Please Try Again!', environment.error_message_type, 'danger', environment.error_icon);
    }
  }

  onEdit() {
    // Logique pour modifier le client
    console.log(`Editing client with ID: ${this.clientId}`);
    // Ajoutez la logique pour rediriger vers une page de modification, si nécessaire
  }

  onDelete() {
    // Logique pour supprimer le client
    console.log(`Deleting client with ID: ${this.clientId}`);
    // Ajoutez la logique pour appeler l'API de suppression, si nécessaire
  }
}
